export default __webpack_public_path__ + "images/592ceaad36414bda3c571649e024db34.png";